// Bernie
import { Store } from 'bernie-plugin-mobx';
import { SerializedData } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

// Mobx
import { makeObservable, observable, action } from 'mobx';

export enum AccountDataState {
  NOT_INITIALIZED,
  PENDING,
  INITIALIZED,
  FAILED,
}

export class AccountDataStateStore extends Store {
  public status: AccountDataState;

  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);

    makeObservable(this, {
      status: observable,
      markNotInitialized: action,
      markAsPending: action,
      markAsInitialized: action,
      markAsFailed: action,
    });

    this.status = AccountDataState.NOT_INITIALIZED;
  }

  public markNotInitialized(): void {
    this.status = AccountDataState.NOT_INITIALIZED;
  }

  public markAsPending(): void {
    this.status = AccountDataState.PENDING;
  }

  public markAsInitialized(): void {
    this.status = AccountDataState.INITIALIZED;
  }

  public markAsFailed(): void {
    this.status = AccountDataState.FAILED;
  }

  public hydrate(data: SerializedData) {
    Object.assign(this, data);
  }
}

export default AccountDataStateStore;
